module.exports = __webpack_public_path__ + "assets/90f629456619d864732944fd684daef8.png";